(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerCategoryDialogController', CustomerCategoryDialogController);

    CustomerCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerCategory'];

    function CustomerCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerCategory) {
        var vm = this;
        vm.customerCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customerCategory.id !== null) {
                CustomerCategory.update(vm.customerCategory, onSaveSuccess, onSaveError);
            } else {
                CustomerCategory.save(vm.customerCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
